// eslint-disable-next-line import/no-cycle
import { getPaymentMethods } from '@/api/purchaseAndSaleAPI'

const rentPlan = {
  state: {
    rentCategory: 1, // 租赁类别进行时（租车/以租代购/司机合作模式），默认为【租车】
    categoryList: [], // 租赁类别list
    orderSignRentFee: null, // 类型为【租车】的费项
    orderSignPurchaseFee: null, // 类型为【以租代购】的费项
    orderSignCooperateFee: null, // 类型为【司机合作模式】的费项
  },
  mutations: {
    set_category: (state, data) => {
      state.rentCategory = data
    },
    // 租赁类别枚举
    set_category_list: (state, data) => {
      state.categoryList = data
    },
    // 设置类型为【租车】的费项
    set_orderSignRentFee: (state, data) => {
      state.orderSignRentFee = data
    },
    // 设置类型为【以租代购】的费项
    set_orderSignPurchaseFee: (state, data) => {
      state.orderSignPurchaseFee = data
    },
    // 设置类型为【司机合作模式】的费项
    set_orderSignCooperateFee: (state, data) => {
      state.orderSignCooperateFee = data
    },
  },
  actions: {
    // 获取类别
    getRentCategory({ commit }) {
      return new Promise((resolve, reject) => {
        getPaymentMethods({ type: 'rentCategory' }).then((res) => {
          commit('set_category_list', res.data || [])
          resolve(res)
        }).catch((error) => {
          console.error('获取租赁类别枚举数据异常', error)
          reject(error)
        })
      })
    },
    // 获取不同类别的费项
    getFeeList({ commit }, params = {}) {
      const commitParams = {
        orderSignRentFee: 'set_orderSignRentFee', // 类型为【租车】的费项
        orderSignPurchaseFee: 'set_orderSignPurchaseFee', // 类型为【以租代购】的费项
        orderSignCooperateFee: 'set_orderSignCooperateFee', // 类型为【司机合作模式】的费项
      }
      return new Promise((resolve, reject) => {
        if (!params.type) {
          console.error(`'入参params:' + ${params.type}`)
          reject()
          return
        }
        getPaymentMethods(params).then((res) => {
          commit(commitParams[params.type], res.data)
          resolve(res)
        }).catch((error) => {
          console.error('获取收款费项枚举数据异常', error)
          reject(error)
        })
      })
    },
  },
}
export default rentPlan

